import VistaInicio from "views/vista-inicio/vista-inicio.view";
import VistaInicioRegiones from "views/vista-inicio/vista-inicio-regiones";
import VistaInicioTematicas from "views/vista-inicio/vista-inicio-tematicas";
import VistaRegiones from "views/vista-regiones/vista-regiones.view";
import VistaTematicasAmbientales from "views/vista-tematicas-ambientales/index";
import VistaTematicasEstadisticas from "views/vista-estadisticas/index";
import VistaMapas from "views/vista-mapas/index";
import VistaPublicaciones from "views/vista-publicaciones/index";
import VistaNormas from "views/vista-normas/index";
import VistaReportes from "views/vista-reportes/vista-reportes.view";
import VistaApps from "views/vista-apps/index";
import VistaTutoriales from "views/vista-tutoriales/index";
import VistaAnalisis from "views/vista-analisis/index";
import Vista404 from "views/vista-404/vista-404.view";


var appRoutes = [
  {
    path: `${process.env.PUBLIC_URL}/`,
    exact: true,
    component: VistaInicioTematicas
  },
  {
    path: `${process.env.PUBLIC_URL}/principal`,
    component: VistaInicio
  },
  {
    path: `${process.env.PUBLIC_URL}/inicio-regiones`,
    component: VistaInicioRegiones
  },
  {
    path: `${process.env.PUBLIC_URL}/estadisticas`,
    component: VistaTematicasEstadisticas
  },{
    path: `${process.env.PUBLIC_URL}/inicio-tematicas`,
    component: VistaInicioTematicas
  },
  {
    path: `${process.env.PUBLIC_URL}/regiones`,
    component: VistaRegiones
  },
  {
    path: `${process.env.PUBLIC_URL}/tematicas`,
    component: VistaTematicasAmbientales
  },
  {
    path: `${process.env.PUBLIC_URL}/analisis`,
    component: VistaAnalisis
  },
  {
    path: `${process.env.PUBLIC_URL}/mapas`,
    component: VistaMapas
  },
  {
    path: `${process.env.PUBLIC_URL}/publicaciones`,
    component: VistaPublicaciones
  },
  {
    path: `${process.env.PUBLIC_URL}/normas`,
    component: VistaNormas
  },
  {
    path: `${process.env.PUBLIC_URL}/reportes`,
    component: VistaReportes
  },
  {
    path: `${process.env.PUBLIC_URL}/apps`,
    component: VistaApps
  },
  {
    path: `${process.env.PUBLIC_URL}/tutoriales`,
    component: VistaTutoriales
  },
  {
    path: `${process.env.PUBLIC_URL}/*`,
    component: Vista404
  }
];
export default appRoutes;
